export default "__VITE_ASSET__zhIyD5zr__"